import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingAdvantagesContainer.css';

export interface INewbuildingAdvantagesContainerProps {
  name: string;
}

export const NewbuildingAdvantagesContainer = ({
  children,
  name,
}: React.PropsWithChildren<INewbuildingAdvantagesContainerProps>) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1 as="h1" fontWeight="bold">
          О ЖК&nbsp;&laquo;{name}&raquo;
        </UIHeading1>
      </div>

      {children}
    </div>
  );
};
